export enum ExportTypeEnum {
    Traditional = 'traditional',
    General = 'general',
    Destination = 'destination'
}
